module.exports = {
  label: {
    headerTitle: 'Dashboard',
    card: {
      employee: 'Employee',
      roster: 'Roster',
      clocking: 'Clocking',
      payrollCalc: 'Payroll Calc',
      report: 'Report',
    }
  }
}